import { Component, Input, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { DynamicFieldsService } from '../dynamic-fields.service';
import * as _ from 'lodash';

@Component({
    selector: 'dynfield-select-search',
    template: require('./dynamic-fields.select-search.component.html')
})
export class DynamicFieldSelectSearchComponent implements OnInit, OnChanges {
    @Input() version: any;
    @Input() field: any;
    @Input() fieldsOptions: any;
    @Input() fieldError: any;
    @Input() allowUpdate: boolean;
    @Input() workflow: any;
    
    public isRequired: boolean;
    public fieldOptions: any;
    public error: any;

    constructor(private dynamicFieldsService: DynamicFieldsService) {}

    ngOnInit() {
        this.error = this.dynamicFieldsService.setError(this.fieldError, this.field);
        this.isRequired = this.dynamicFieldsService.isRequired(this);

        if (Array.isArray(this.fieldsOptions)) {
            this.fieldOptions = {
                fieldElements: this.fieldsOptions
            };
        } else {
            this.fieldOptions = this.dynamicFieldsService.getFieldOptions(
                this.fieldsOptions, this.field, this.workflow
            );
        }

        this.field.fieldData = this.getSelectedElement(
            _.get(this.field, 'fieldData', false),
            _.get(this.fieldOptions, 'fieldElements', [])
        );
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.fieldError) {
            this.error = this.dynamicFieldsService.setError(
                changes.fieldError?.currentValue, this.field
            );
        }
    }

    onItemSelect(item: any) {
        this.field.fieldData = item;
    }

    private getSelectedElement(fieldData: any, elements: any[]): any {
        const selectedOption = _.find(elements, { id: _.get(fieldData, 'id', 0) });
        const noChangeOption = _.find(elements, { id: -1 });
        const defaultOption = _.find(elements, { defaultSelected: true });
        
        return selectedOption || noChangeOption || defaultOption;
    }
}
